import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import {
  Container,
  Card,
  Form,
  Row,
  Col,
  ButtonGroup,
  Button,
} from "react-bootstrap";
import { ThreeDots } from 'react-loader-spinner';
import { getEntitlebyID, deleteEntitlebyID, updateLeaveEntitlement, resetList, updateEntitlebyID } from "../../3.Store/LeaveEntitlementSlice";

const LeaveEntitlementForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loading = useSelector(state => state.LeaveEntitlementSlice.loading);
  const entitle = useSelector(state => state.LeaveEntitlementSlice.entitle);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const { annual, sick, medical, hospitalization, service_length, employee_catagory } = entitle;

  useEffect(() => {
    console.log("ID:", id);
    window.scrollTo(0, 0);
    if (id) {
      dispatch(getEntitlebyID({id}))
        .catch((err) => {
          console.error("Failed to fetch leave entitlement:", err);
        });
    } else {
      dispatch(resetList());
    }
  }, [id]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleUpdate = (e) => {
    const entity = { ...entitle, [e.target.name]: e.target.value };
    console.log(entity);
    dispatch(updateLeaveEntitlement(entity));
  };

  const handleBtnUpdate = () => {
    const int = v => Number(v) | 0;

    const entity = {
      ...entitle,
      description: `Annual:${int(annual)}, Sick:${int(sick)}, Hospitalization:${int(hospitalization)}, Medical ${int(medical)}`
    };

    dispatch(updateEntitlebyID(entity))
      .unwrap()
      .then(() => {
        Swal.fire("Record Updated", "", "success").then(() => {
          navigate(`/Entitlement`);
        });
      })
      .catch((err) => {
        Swal.fire("Error", err.message, "error");
      });
  };      

  const handleBtnDelete = async () => {
    const result = await Swal.fire({
      // title: "Are you sure?",
      text: `Confirm delete entitlement for ${employee_catagory.description} with service length ${service_length.description}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No"
    });

    if (result.isConfirmed) {
      dispatch(deleteEntitlebyID({ id: entitle.id }))
        .unwrap()
        .then(() => {
          Swal.fire("Record Deleted", "", "success").then(() => {
            navigate(`/Entitlement`);
          });
        })
        .catch((err) => {
          Swal.fire("Error", err.message, "error");
        });
    }
  };      
  
  const handleBtnBack = () => {
    dispatch(resetList());
    navigate(`/Entitlement`);
  };

  return (
    <Container className="ContainerContent">
      {loading && (
        <ThreeDots
          visible={loading}
          height="80"
          width="80"
          color="#4fa94d"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: '9999',
          }}
        />
      )}
      <Card className="CardContent2">

        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
        </div>

        <h1 className="TitleHeader">Leave Entitlement</h1>
        <h1 className="MiniTitleHeader">Edit</h1>

        <Row className="my-3">
          <Col md={12} sm={12}>
            <Row>
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Employee Category</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control value={employee_catagory.description} readOnly disabled/>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="my-3">
          <Col md={12} sm={12}>
            <Row>
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Service Length</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control value={service_length.description} readOnly disabled />
              </Col>
            </Row>
          </Col>
        </Row>

        <hr className="hr-white" />

        <Row className="my-3">
          <Col md={12} sm={12}>
            <Row>
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Annual Leave</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control name="annual" value={annual} onChange={handleUpdate}/>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="my-3">
          <Col md={12} sm={12}>
            <Row>
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Sick Leave</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control name="sick" value={sick} onChange={handleUpdate}/>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="my-3">
          <Col md={12} sm={12}>
            <Row>
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Medical Claim</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control name="medical" value={medical} onChange={handleUpdate}/>
              </Col>
            </Row>
          </Col>
        </Row>

        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
          &nbsp; &nbsp;
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnDelete}>
              Delete
            </Button>
            &nbsp; &nbsp;
            <Button className="Button" onClick={handleBtnUpdate}>
              Update
            </Button>
          </ButtonGroup>
        </div>
      </Card>
    </Container>
  );
};

export default LeaveEntitlementForm;